<template>
  <accordion-item-fi
    v-if="hasTextList"
    class="accordion-learning-targets-fi"
    header-tag="h3"
    ignore-others
    scroll-to
  >
    <template #header>
      {{ $dict.get('product-Catalog.Accordions.Learning-Targets') }}
    </template>
    <template #content>
      <div class="accordion-learning-targets-fi__content">
        <div class="accordion-learning-targets-fi__column">
          <richtext-fi
            class="accordion-learning-targets-fi__text"
            :html-content="{ value: hasTextList }"
          />
        </div>
      </div>
    </template>
  </accordion-item-fi>
</template>

<script>
import { AccordionItemFi, RichtextFi } from 'atoms';

import breakpointMixin from '@/mixins/breakpointMixin.vue';
import catalogMixin from '@/mixins/catalogMixin.vue';

export default {
  name: 'AccordionLearningTargetsFi',
  components: {
    AccordionItemFi,
    RichtextFi,
  },
  mixins: [breakpointMixin, catalogMixin],
  props: {
    catalogData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    textList() {
      return this.catalogData?.TextList;
    },
    hasTextList() {
      return this.textListValue(this.textList, 'LEARNING_OBJECTIVE');
    },
  },
};
</script>

<style src="./accordion-learning-targets-fi" />
